'use strict';

/* jshint -W098 */
angular.module('mean.tradesman').controller('TradesmanPastReportController', ['$scope', '$rootScope', 'Users', 'Global', 'Foreman', 'MeanUser', 'ProjectTasks', '$filter', 'Projects', '$location', 'ProjectHours', 'toaster', 'userService', 'Trades', 'aceUtils', 'tradeCodeService', '$q', 'ngDialog', 'Hours', 'myCoordinates', 'Timecards', 'PayPeriodService',
  function($scope, $rootScope, Users, Global, Foreman, MeanUser, ProjectTasks, $filter, Projects, $location, ProjectHours, toaster, userService, Trades, aceUtils, tradeCodeService, $q, ngDialog, Hours, myCoordinates, Timecards, PayPeriodService) {
    $scope.global = Global;
    $scope.package = {
      name: 'tradesman'
    };

    $scope.startDate = 0;
    $scope.endDate = 0;
    $scope.dateFormat = 'MM/DD/YYYY';
    $scope.dateFormatFull = 'MM/DD/YYYY : HH:mm:ss';

    $scope.menu = ['Payroll Period', 'Time Cards'];
    $scope.current_menu = 'Payroll Period';

    $scope.tasks = [];
    $scope.hours = [];
    $scope.report_dates = [];
    $scope.view = '';
    $scope.total_hours = 0;
    $scope.total_costs = 0;
    $scope.report_view = 'task';
    $scope.working_projects = [];
    $scope.is_manager = false;
    $scope.is_foreman = false;
    $scope.is_admin = false;
    $scope.viewingCurrentWeek = true;
    $scope.shouldShowSpinner = true;
    $scope.x = 0;
    $scope.y = 0;
    var loginDialog = null;
    $scope.userIsVerified = true;
    $scope.biweekly = false;
    $scope.userTotals = {};
    $scope.employees = [];
    $scope.selectedEmployee= {};
    $scope.userTimeCard= {};

    $scope.user = MeanUser.user;

    $scope.selectedEmployee = $scope.user;
    $scope.verifiedUser = $scope.user;

    $scope.incrementPayPeriod = function(period) {
        if(period === 'weekly') {
            $scope.payEndDate.add(7, 'days');
        } else if(period === 'biweekly') {
            $scope.payEndDate.add(14, 'days');
        }

        if($scope.payStartDate <= $scope.payToday && $scope.payToday <= $scope.payEndDate) {
            if(period === 'weekly') {
                $scope.payStartDate = moment($scope.payEndDate).subtract(7, 'days');
            } else if(period === 'biweekly') {
                $scope.payStartDate = moment($scope.payEndDate).subtract(14, 'days');
            }
            return -1;
        }
        else
          return 0;
    };

    userService.getMainAccount($scope.user.username).then(function(main_account) {
        $scope.main_account = main_account;

        Trades.query({'main_account_id': $scope.main_account._id}, function(trade) {
            trade[0].company_code =
                    aceUtils.padDigits(trade[0].company_code, 3);
            trade[0].trade_code = tradeCodeService.getCode(trade[0].trade);
            $scope.trade = trade[0];

            if(!$scope.trade.payroll_end_date || !$scope.trade.payroll_period) {
                toaster.pop('error', 'No Payroll Settings', 'Please set payroll settings in Company Admin');
                return;
            }

            if($scope.trade.payroll_period === 'biweekly') {
                $scope.biweekly = true;
            }

            $scope.pay_periods = PayPeriodService.setPayPeriods($scope.trade);
            //$scope.pay_periods = $scope.pay_periods.slice(Math.max($scope.pay_periods.length - 8, 1));
            $scope.pay_periods.reverse();

            $scope.selectedPayPeriod = $scope.pay_periods[0];

            $scope.payStartDate = moment($scope.selectedPayPeriod.start);
            $scope.payEndDate = moment($scope.selectedPayPeriod.end);
            $scope.payToday = moment();

            $scope.getHours();
            $scope.getUserHours($scope.user);
        });
    });

    $scope.changePayPeriod = function() {
        $scope.shouldShowSpinner = true;

        $scope.payStartDate = moment($scope.selectedPayPeriod.start);
        $scope.payEndDate = moment($scope.selectedPayPeriod.end);
        $scope.payToday = moment();
        $scope.getHours();

        // if($scope.is_manager) {
        //     $scope.getUserHours($scope.selectedEmployee);
        // } else if($scope.userIsVerified) {
            $scope.getUserHours($scope.verifiedUser);
            $scope.buildPayrollTable();
        // }
    };

    $scope.getHours = function() {
        $scope.getTradesmanHours();
    };

    $scope.buildPayrollTable = function() {
        $scope.employees = $filter('unique')($scope.payroll_hours, 'username');
        $scope.employees = $filter('orderBy')($scope.employees, 'name');
        $scope.pay_dates = [];
        var users = angular.copy($scope.users);

        var current_date = moment($scope.payStartDate);
        while(!$scope.payEndDate.isSame(current_date, 'day')) {
            $scope.pay_dates.push(moment(current_date));

            current_date = current_date.add(1, 'day');
        }

        $scope.pay_dates.push(moment(current_date));

        var emp = $scope.user;

        console.log('building the data table');
        emp.grand_total = 0;
        emp.payroll_hours = [];
        _.each($scope.pay_dates, function(day) {
            var first_list = $filter('filter')($scope.payroll_hours, {
                'username': emp.username }, true);

            var hours = 0;
            var diff_proj_hours = false;
            _.each(first_list, function(item) {
                if(moment(item.date).isSame(day, 'day')) {
                    if(item.different_project) {
                        hours += item.hours;
                        diff_proj_hours = true;
                    } else {
                        hours += item.hours;
                    }
                }
            });

            //need to store the hours but also note what
            //kind of hours they are so we can control
            //the display better.
            if(day <= moment()) {
                emp.payroll_hours.push({
                    hours: angular.copy(hours),
                    type: diff_proj_hours?'diffhours':'regular'
                });
                emp.grand_total += hours;
            } else {
                emp.payroll_hours.push({
                    hours: 0,
                    type: 'future'
                });
            }
        });

        //remove any employee that does not have hours
        // _.remove(users, function(usr) {
        //     return usr.grand_total === 0 || $scope.removeNoRegularHours(usr);
        // });

        $scope.shouldShowSpinner = false;

        $scope.all_users = users;
    };

    // $scope.removeNoRegularHours = function(usr) {
    //     var result = $filter('filter')(usr.payroll_hours, {'type': 'regular'}, true);
    //     _.remove(result, function(item) {
    //         return item.hours === 0;
    //     });
    //     return result.length === 0;
    // };

    $scope.getProjectHours = function() {
        var deferred = $q.defer();
        var returned_items = [];

        ProjectHours.query({'trade': $scope.trade.trade, 
            'company_code': $scope.trade.company_code,
            //'user': $scope.user._id,
            'type': 'dateRange',
            'start': new Date($scope.payStartDate), 
            'end': new Date($scope.payEndDate) }, function(payroll_hours) {
            _.each(payroll_hours, function(hour) {
                returned_items.push(hour);
            });

            $q.all(returned_items).then(function(results) {
                deferred.resolve(results);
            });
        });

        return deferred.promise;
    };

    $scope.getUserProjectHours = function(uName) {
        var deferred = $q.defer();
        //var returned_items = [];

        ProjectHours.query({'trade': $scope.trade.trade, 
            'company_code': $scope.trade.company_code,
            'type': 'userDateRange',
            'username': uName,
            'start': new Date($scope.payStartDate), 
            'end': new Date($scope.payEndDate) }, function(payroll_hours) {

            deferred.resolve(payroll_hours);
        });

        return deferred.promise;
    };

    $scope.getTradesmanHours = function() {
        $scope.payroll_hours = [];

        $scope.getProjectHours().then(function(payroll_hours) {
            _.each(payroll_hours, function(hour) {
                if(hour.foreman_id === $scope.user._id) {
                    hour.different_project = false;
                } else {
                    hour.different_project = true;
                }
                $scope.payroll_hours.push(hour);
            });

            $scope.buildPayrollTable();
        });
    };

    $scope.init = function() {

    };

    $scope.onSelect = function(item) {
        $scope.current_menu = item;
    };

    $scope.ranges = {
        'Today': [moment(), moment()],
        'Yesterday': [moment().subtract(1, 'days'), moment().subtract(1, 'days')],
        'Last 7 days': [moment().subtract(7, 'days'), moment()],
        'Last 30 days': [moment().subtract(30, 'days'), moment()],
        'This month': [moment().startOf('month'), moment().endOf('month')]
    };

    $scope.getUserHours = function(vUser) {
        $scope.userTotals = {
            hours: 0,
            hours_ms: 0,
            ot_hours: 0,
            dt_hours: 0,
            production_bonus: 0,
            effective_rate: 0,
            break_pay: 0,
            premium_ot: 0
        }

        $scope.user_hours = [];
        var current_day = new moment($scope.payStartDate);
        $scope.user_hours = _.times($scope.biweekly?14:7, function() {
            var obj = {
                date: current_day.clone(),
                total: '00:00:00',
                task_hours: 0,
                production_bonus: 0,
                extra_break_money: 0,
                hours_over_time: 0,
                hours_double_time: 0,
                premium_overtime: 0,
                clock_in: {
                    time: null
                },
                lunch_start: {
                    time: null
                },
                lunch_end: {
                    time: null
                },
                clock_out: {
                    time: null
                },
            }
            current_day = new moment(current_day.add(1, 'day'));
            return obj;
        });

        Timecards.query({'trade_code': userService.getTradeCode($scope.user.username),
            'company_code': $scope.user.contractor_code,
            'user': vUser._id }, function(timecardDB) {

            //var today = moment();
            var found = _.remove(timecardDB, function(tc) {
                return moment(tc.start_date) <= $scope.payStartDate &&
                    $scope.payEndDate <= moment(tc.end_date);
            });

            if(found && found.length === 1) {
                $scope.userSignedTC = true;
                _.each(found[0].hours, function(time) {
                    time.date = moment(time.date);
                    if(time.clock_in)
                        time.clock_in.time = moment(time.clock_in.time);//.format("h:mm:ss a");
                    if(time.lunch_start)
                        time.lunch_start.time = moment(time.lunch_start.time);
                    if(time.lunch_end)
                        time.lunch_end.time = moment(time.lunch_end.time);
                    if(time.clock_out)
                        time.clock_out.time = moment(time.clock_out.time);

                    var first = null;
                    var second = null;

                    if(time.lunch_start && time.clock_in)
                        first = moment.duration(time.lunch_start.time.diff(time.clock_in.time));

                    if(time.clock_out && time.lunch_end.time)
                        second = moment.duration(time.clock_out.time.diff(time.lunch_end.time));

                    if(first !== null && second !== null) {
                        var final = moment.duration(first.add(second));
                        time.total = moment.utc(final.asMilliseconds()).format("HH:mm:ss");
                    } else {
                        time.total = 'N/A';
                    }
                });

                var ordered = $filter('orderBy')(found[0].hours, 'date');
                var hours_data = ordered;
                
                _.each(hours_data, function(uHour) {
                    uHour.task_hours = 0;
                    uHour.production_bonus = 0;
                    uHour.extra_break_money = 0;
                    uHour.hours_over_time = 0;
                    uHour.hours_double_time = 0;
                    uHour.premium_overtime = 0;
                });

                $scope.getUserProjectHours(vUser.username).then(function(pHours) {
                    //here is where i need to find the dates to match them up 
                    //and add shit to user_hours.
                    _.each(pHours, function(hour) {
                        _.each(hours_data, function(uHour) {
                            if(moment(hour.date).isSame(moment(uHour.date), 'day')) {
                                console.log('these guys match up');
                                uHour.task_hours += hour.hours;
                                uHour.production_bonus += hour.production_bonus;
                                uHour.extra_break_money += hour.extra_break_money;
                                uHour.hours_over_time += hour.hours_over_time;
                                uHour.hours_double_time += hour.hours_double_time;
                                uHour.premium_overtime += hour.premium_overtime;
                            }
                        });
                    });

                    _.each(hours_data, function(uHour) {
                        var idx = _.findIndex($scope.user_hours, function(o) {
                            return o.date.isSame(uHour.date, 'day');
                        });

                        if(idx !== -1)
                          $scope.user_hours.splice(idx, 1, uHour);
                    });

                    _.each(pHours, function(hour) {
                        //$scope.userTotals.hours += hour.total;
                        $scope.userTotals.ot_hours += hour.hours_over_time;
                        $scope.userTotals.dt_hours += hour.hours_double_time;
                        $scope.userTotals.production_bonus += hour.production_bonus;
                        //$scope.userTotals.effective_rate += hour.;
                        $scope.userTotals.break_pay += hour.extra_break_money;
                        $scope.userTotals.premium_ot += hour.premium_overtime;
                    });
                });

                $scope.userTotals = {
                    hours: found[0].total.hours,
                    //hours_ms: 0,
                    ot_hours: found[0].total.overtime_hours,
                    dt_hours: found[0].total.double_hours,
                    production_bonus: found[0].total.production_bonus,
                    effective_rate: found[0].total.effective_rate,
                    break_pay: found[0].total.extra_break_money,
                    premium_ot: found[0].total.premium_overtime
                }

                $scope.userTimeCard = found[0];
                if($scope.userTimeCard.info)
                    $scope.userTimeCard.info.date = new Date($scope.userTimeCard.info.date);
            } else if(found.length > 1) {
                toaster.pop('error', 'Time Card Error', 'Contact Admin');
            } else {
                $scope.getHoursData(vUser);
                $scope.userTimeCard = null;
                $scope.userSignedTC = false;
            }
        });
    };

    $scope.getHoursData = function(vUser) {
        Hours.query({ 'trade_code': userService.getTradeCode($scope.user.username),
            'company_code': $scope.user.contractor_code,
            'type': 'UserDateRange',
            'user': vUser._id,
            'start': new Date($scope.payStartDate),
            'end': new Date($scope.payEndDate) }, function(timesdb) {
            _.each(timesdb, function(time) {
                time.date = moment(time.date);
                if(time.clock_in)
                    time.clock_in.time = moment(time.clock_in.time);//.format("h:mm:ss a");
                if(time.lunch_start)
                    time.lunch_start.time = moment(time.lunch_start.time);
                if(time.lunch_end)
                    time.lunch_end.time = moment(time.lunch_end.time);
                if(time.clock_out)
                    time.clock_out.time = moment(time.clock_out.time);

                var first = null;
                var second = null;

                if(time.lunch_start && time.clock_in)
                    first = moment.duration(time.lunch_start.time.diff(time.clock_in.time));

                if(time.clock_out && time.lunch_end.time)
                    second = moment.duration(time.clock_out.time.diff(time.lunch_end.time));

                if(first !== null && second !== null) {
                    var final = moment.duration(first.add(second));
                    time.total = moment.utc(final.asMilliseconds()).format("HH:mm:ss");
                    time.seconds = parseFloat(final.asSeconds());
                } else {
                    time.total = 'N/A';
                }
            });

            var ordered = $filter('orderBy')(timesdb, 'date');
            var hours_data = ordered;
            var seconds = 0;
            _.each(hours_data, function(uHour) {
                uHour.task_hours = 0;
                uHour.production_bonus = 0;
                uHour.extra_break_money = 0;
                uHour.hours_over_time = 0;
                uHour.hours_double_time = 0;
                uHour.premium_overtime = 0;
                seconds += uHour.seconds;
            });

            $scope.userTotals.hours = seconds/3600;

            $scope.getUserProjectHours(vUser.username).then(function(pHours) {
                //here is where i need to find the dates to match them up 
                //and add shit to user_hours.
                _.each(pHours, function(hour) {
                    _.each(hours_data, function(uHour) {
                        if(moment(hour.date).isSame(moment(uHour.date), 'day')) {
                            console.log('these guys match up');
                            uHour.task_hours += hour.hours;
                            uHour.production_bonus += hour.production_bonus;
                            uHour.extra_break_money += hour.extra_break_money;
                            uHour.hours_over_time += hour.hours_over_time;
                            uHour.hours_double_time += hour.hours_double_time;
                            uHour.premium_overtime += hour.premium_overtime;

                        }
                    });
                });

                _.each(hours_data, function(uHour) {
                    var idx = _.findIndex($scope.user_hours, function(o) {
                        return o.date.isSame(uHour.date, 'day');
                    });

                    if(idx !== -1)
                      $scope.user_hours.splice(idx, 1, uHour);
                });

                _.each(pHours, function(hour) {
                    //$scope.userTotals.hours += hour.total;
                    $scope.userTotals.ot_hours += hour.hours_over_time;
                    $scope.userTotals.dt_hours += hour.hours_double_time;
                    $scope.userTotals.production_bonus += hour.production_bonus;
                    //$scope.userTotals.effective_rate += hour.;
                    $scope.userTotals.break_pay += hour.extra_break_money;
                    $scope.userTotals.premium_ot += hour.premium_overtime;
                });
            })
        });
    };

    $rootScope.$on('userVerifiedTCSign', function(event, data){
        console.log('verified user identity for timecard');
        if(!loginDialog) return;
        
        loginDialog.close();
        
        $scope.userSignedTC = true;

        myCoordinates.get().then(function(coords) {
            //user_hours represent every day of the pay period.
            //remove the days not worked.
            var save_hours = angular.copy($scope.user_hours);

            _.remove(save_hours, function(hour) {
                return hour._id === undefined;
            });

            if($scope.userTimeCard) {
                $scope.userTimeCard.hours = save_hours;
                $scope.userTimeCard.signed = true;
                $scope.userTimeCard.info = {
                    date: new Date(),
                    location: {
                        lat: coords.lat,
                        lon: coords.lon
                    },
                    code: 'E'
                };
                $scope.userTimeCard.total = {
                    hours: $scope.userTotals.hours,
                    overtime_hours: $scope.userTotals.ot_hours,
                    double_hours: $scope.userTotals.dt_hours,
                    production_bonus: $scope.userTotals.production_bonus,
                    effective_rate: $scope.userTotals.effective_rate,
                    extra_break_money: $scope.userTotals.break_pay,
                    premium_overtime: $scope.userTotals.premium_ot
                }

                $scope.userTimeCard.$update(function(success) {
                    $scope.userTimeCard = success;
                    $scope.userTimeCard.info.date = new Date($scope.userTimeCard.info.date);
                    toaster.pop('success', 'Time Card Signed');
                }, function(error) {
                    toaster.pop('error', 'Time Card Error', error);
                });
            } else {
                var tc = new Timecards({
                    user: $scope.user,
                    trade_code: userService.getTradeCode($scope.user.username),
                    company_code: $scope.user.contractor_code,
                    start_date: new Date($scope.payStartDate),
                    end_date: new Date($scope.payEndDate),
                    hours: save_hours,
                    signed: true,
                    info: { //info at the time of signing
                        date: new Date(),
                        location: {
                            lat: coords.lat,
                            lon: coords.lon
                        },
                        code: 'E'
                    },
                    total: {
                        hours: $scope.userTotals.hours,
                        overtime_hours: $scope.userTotals.ot_hours,
                        double_hours: $scope.userTotals.dt_hours,
                        production_bonus: $scope.userTotals.production_bonus,
                        effective_rate: $scope.userTotals.effective_rate,
                        extra_break_money: $scope.userTotals.break_pay,
                        premium_overtime: $scope.userTotals.premium_ot
                    }
                });

                tc.$save(function(success) {
                    $scope.userSignedTC = true;
                    $scope.userTimeCard = success;
                    $scope.userTimeCard.info.date = new Date($scope.userTimeCard.info.date);
                    toaster.pop('success', 'Time Card Signed');
                }, function(error) {
                    toaster.pop('error', 'Time Card Error', error);
                })
            }
        });

        loginDialog = null;
    });

    $scope.signTimeCard = function() {
        $scope.returnedOptions = {
            username: $scope.selectedEmployee.username,
            password: '',
            type: 'TimeCardSignVerification'
        };

        loginDialog = ngDialog.open({
            template: 'foreman/views/tmpl/password.html',
            scope: $scope,
            className: 'ngdialog-theme-default'
        });
    };
  }
]);


// WEBPACK FOOTER //
// ./packages/custom/tradesman/public/controllers/tradesman_past.js